// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import api from './axios'
import { Dealer, CreateDealerData, UpdateDealerData } from '@crm-src/types/dealer'

class DealersApiService {
  async getByReseller(resellerId: string): Promise<Dealer[]> {
    const response = await api.get(`/resellers/${resellerId}/dealers`)
    return response.data
  }

  async create(resellerId: string, data: CreateDealerData): Promise<Dealer> {
    const response = await api.post(`/resellers/${resellerId}/dealers`, { dealer: data })
    return response.data
  }

  async update(id: string, data: UpdateDealerData): Promise<Dealer> {
    const response = await api.patch(`/dealers/${id}`, { dealer: data })
    return response.data
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/dealers/${id}`)
  }
}

export const dealersApiService = new DealersApiService()
export default dealersApiService



